import { render, staticRenderFns } from "./Gray.vue?vue&type=template&id=45fa62c6&scoped=true&"
import script from "./Gray.vue?vue&type=script&lang=ts&"
export * from "./Gray.vue?vue&type=script&lang=ts&"
import style0 from "./Gray.vue?vue&type=style&index=0&id=45fa62c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fa62c6",
  null
  
)

export default component.exports